import React from "react"

import classNames from "classnames"

import { DragOriginContextProvider } from "shared/context/drag-and-drop/DragOriginContext"

import { TabBarContext } from "../context/TabBarContext"
import { useTabBarDraggableViewModel } from "../model/useTabBarDraggableViewModel"
import { useTabListKeyboardNavigation } from "../model/useTabListKeyboardNavigation"
import type { TabBarRootProps } from "./TabBarRoot"

export const TabBarSortableRoot = React.memo(
  ({ children, ...props }: TabBarRootProps) => {
    const { context, containerProps } = useTabBarDraggableViewModel(props)
    const handleKeyDown = useTabListKeyboardNavigation()
    return (
      <DragOriginContextProvider>
        <TabBarContext.Provider value={context}>
          <div
            {...containerProps}
            className={classNames(
              "tab-bar",
              "nav",
              "nav-tabs",
              props.className
            )}
            role="tablist"
            tabIndex={-1}
            onKeyDown={handleKeyDown}
          >
            {children}
          </div>
        </TabBarContext.Provider>
      </DragOriginContextProvider>
    )
  }
)

TabBarSortableRoot.displayName = "TabBar.SortableRoot"
